<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00866 14.1252C8.85033 14.1252 8.69199 14.0669 8.56699 13.9419L7.31699 12.6919C7.07533 12.4502 7.07533 12.0502 7.31699 11.8085C7.55866 11.5669 7.95866 11.5669 8.20033 11.8085L9.00866 12.6169L11.9003 9.7252C12.142 9.48353 12.542 9.48353 12.7837 9.7252C13.0253 9.96686 13.0253 10.3669 12.7837 10.6085L9.45033 13.9419C9.33366 14.0669 9.16699 14.1252 9.00866 14.1252Z"
      :fill="color"
    />
    <path
      d="M11.667 5.62533H8.33366C7.53366 5.62533 6.04199 5.62533 6.04199 3.33366C6.04199 1.04199 7.53366 1.04199 8.33366 1.04199H11.667C12.467 1.04199 13.9587 1.04199 13.9587 3.33366C13.9587 4.13366 13.9587 5.62533 11.667 5.62533ZM8.33366 2.29199C7.50866 2.29199 7.29199 2.29199 7.29199 3.33366C7.29199 4.37533 7.50866 4.37533 8.33366 4.37533H11.667C12.7087 4.37533 12.7087 4.15866 12.7087 3.33366C12.7087 2.29199 12.492 2.29199 11.667 2.29199H8.33366Z"
      :fill="color"
    />
    <path
      d="M12.5 18.9587H7.5C2.81667 18.9587 1.875 16.8087 1.875 13.3337V8.33368C1.875 4.53368 3.25 2.90868 6.63333 2.73368C6.975 2.71702 7.275 2.97535 7.29167 3.32535C7.30833 3.67535 7.04167 3.95868 6.7 3.97535C4.33333 4.10868 3.125 4.81702 3.125 8.33368V13.3337C3.125 16.417 3.73333 17.7087 7.5 17.7087H12.5C16.2667 17.7087 16.875 16.417 16.875 13.3337V8.33368C16.875 4.81702 15.6667 4.10868 13.3 3.97535C12.9583 3.95868 12.6917 3.65868 12.7083 3.31702C12.725 2.97535 13.0167 2.70868 13.3667 2.72535C16.75 2.90868 18.125 4.53368 18.125 8.32535V13.3253C18.125 16.8087 17.1833 18.9587 12.5 18.9587Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
